import { useState } from 'react'
import { createParam } from 'solito'
import { useStaticContentPagesQuery } from './queries'
import { StaticContentScreen } from './static-content-screen'
import { ErrorScreen404 } from 'app/features/errors/screens'

const { useParam } = createParam<{ slug: string }>()

export interface StaticContentScreenContainerProps {
  preview?: boolean
}

export const StaticContentScreenContainer = (props: StaticContentScreenContainerProps) => {
  const [slugBase] = useParam('slug')
  const [refreshing, setRefreshing] = useState(false)

  let slug = slugBase

  if (Array.isArray(slug)) {
    slug = slug.join('/')
  }

  const { loading, data, refetch, error } = useStaticContentPagesQuery({
    slug: slug || '',
    draft: !!props.preview,
  })
  const page = data?.StaticContentPages?.docs?.[0]

  const handlePullToRefresh = async () => {
    setRefreshing(true)
    await Promise.all([refetch()])
    setRefreshing(false)
  }

  if (!loading && !page) {
    console.log('Page not found', slug)
    return <ErrorScreen404 />
  }

  if (error) {
    console.error('Error loading static content page', error)
    return <ErrorScreen404 />
  }

  return (
    <StaticContentScreen
      loading={loading}
      page={page}
      refreshing={refreshing}
      onPullToRefresh={handlePullToRefresh}
    />
  )
}
